import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ISession } from '../../../models/session';
import { TranslateService } from '@ngx-translate/core';
import { WizardService } from '../wizard/wizard.service';
import { IWizardForm } from '../wizard/wizard-form.component';
import { registrationForm } from '../wizard/registration-form';
import { UsersService } from '../users/users.service';
import { IField } from './form/form.component';
import { SessionsService } from '../sessions.service';
import { pick } from 'ramda';

@Component({
  templateUrl: './registration.component.html'
})
export class SessionsRegistrationComponent implements OnInit {
  public session: ISession;
  public fields: IField[] = [];

  constructor(
    private route: ActivatedRoute,
    private translateService: TranslateService,
    private usersService: UsersService,
    private router: Router,
    private sessionsService: SessionsService
  ) {}

  ngOnInit() {
    this.route.parent.data
      .map(route => route.data)
      .subscribe((session: ISession) => {
        this.session = session;
        this.getForm();
      });
  }

  edit(fields: IField[]) {
    const updatedFields = (fields || []).map(pick(['name', 'type', 'required', 'readonly', 'values']));
    this.usersService.updateRegistration(this.session, { data: updatedFields }).subscribe(customFields => {
      this.fields = this.fields.filter(field => field.readonly).concat(customFields);
      this.sessionsService.setComplete(this.session, 'registration');
    });
  }

  private getForm() {
    this.usersService.getRegistration(this.session).subscribe(fields => {
      this.fields = fields;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/sessions/registration/registration.component.ts